@if (sideMenuMapping[selectedSideMenuName]; as menuItems) {
  <app-side-menu [isSidebarMenu]="true">
    @for (menuItem of menuItems; track menuItem) {
      <ng-container *appPermission="menuItem?.requiredPermission || null">
        <app-side-menu-item
          *appRequiredUserRoles="menuItem?.requiredUserRoles; and: user"
          data-test="side-menu-item"
          [sectionName]="selectedSideMenuName"
          [hidden]="menuItem.hidden"
          [name]="menuItem.name"
          [link]="menuItem.link"
          [queryParams]="menuItem.queryParams"
          [exact]="menuItem.exact === undefined ? true : menuItem.exact"
        >
          @for (submenuItem of menuItem.submenu; track submenuItem) {
            <app-side-menu-item
              data-test="side-sub-menu-item"
              [sectionName]="selectedSideMenuName"
              [name]="submenuItem.name"
              [link]="submenuItem.link"
              [queryParams]="submenuItem.queryParams"
              [exact]="menuItem.exact === undefined ? true : menuItem.exact"
              [isSubmenu]="true"
            />
          }
        </app-side-menu-item>
      </ng-container>
    }
  </app-side-menu>
}
